import React from 'react'
import { RouterProvider } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { router } from 'router'
import { AuthProvider } from 'context/AuthContext'
import SessionExpiredModal from 'shared/components/SessionExpiredModal'
import 'react-toastify/dist/ReactToastify.css'

function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
      <SessionExpiredModal />
      <ToastContainer theme="light" position="top-center" />
    </AuthProvider>
  )
}

export default App
